(function () {
  'use strict';
  const root = document.getElementById('promotion-campaign');
  if (!root) return;
  const zh = root.dataset.locale.startsWith('zh');
  const t = (en, cn) => zh ? cn : en;
  const campaignId = new URLSearchParams(location.search).get('campaign');
  const api = '/apps/gift-promotions';
  const store = window.PromotionStorage?.forCustomer(root.dataset.customer);
  const $ = selector => root.querySelector(selector);
  let campaign, eligible = false, grant = '', busy = false;
  const saved = store?.campaigns() || {};
  function localized(value) { return value?.[root.dataset.locale] || (zh && (value?.['zh-TW'] || value?.['zh-CN'])) || value?.en || ''; }
  function money(value) { return new Intl.NumberFormat(root.dataset.locale, { style: 'currency', currency: campaign.currency }).format(value); }
  async function request(path, body) {
    const response = await fetch(api + path, body ? { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) } : {});
    const result = await response.json().catch(() => null);
    if (!result) throw new Error(t('The promotion service is temporarily unavailable', '優惠服務暫時無法使用') + ` (HTTP ${response.status}). ` + t('Please reload or contact the store.', '請重新載入或聯絡商店。'));
    if (!response.ok) throw new Error(result.code ? eligibilityMessage(result.code) : response.status >= 500 ? t('The promotion service is temporarily unavailable. Please try again.', '優惠服務暫時無法使用，請稍後重試。') : result.error || t('Please try again.', '請重試。'));
    if (result.customerId !== undefined && String(result.customerId) !== String(root.dataset.customer || '')) {
      throw new Error(t('Your sign-in has changed. Please reload this page.', '您的登入狀態已變更，請重新載入此頁面。'));
    }
    return result;
  }
  function message(text, error = false) { $('.campaign-message').textContent = text; $('.campaign-message').classList.toggle('error', error); }
  function eligibilityMessage(state = campaign.state) {
    return ({
      sign_in_required: t('Sign in or create an account to check this offer.', '請登入或建立帳戶以查看此優惠。'),
      email_access_unavailable: t('We cannot check your email right now. Please contact the store or try again later.', '暫時無法核實您的電郵，請聯絡商店或稍後重試。'),
      domain_mismatch: t('Your account email does not qualify for this offer. Sign in with your eligible email account.', '您的帳戶電郵不符合此優惠資格，請使用合資格的電郵帳戶登入。'),
      code_required: t('Apply a valid code to unlock your gifts.', '套用有效優惠碼以解鎖禮品。')
    })[state] || t('This offer is currently unavailable.', '此優惠暫不可用。');
  }
  function currentVariant() { return campaign.product.variants.nodes.find(v => v.id === $('.campaign-variant').value); }
  function selectedGifts() {
    return Array.from(root.querySelectorAll('.campaign-gift-input')).map(input => ({
      key: input.dataset.key, shopify_variant_id: input.dataset.variant,
      quantity: input.type === 'radio' ? Number(input.checked) : Number(input.value)
    })).filter(item => item.quantity > 0);
  }
  function update() {
    const variant = currentVariant();
    const price = eligible && campaign.config.promotional_price != null ? campaign.config.promotional_price : Number(variant.price);
    const priceEl = $('.campaign-price'); priceEl.replaceChildren();
    if (price < Number(variant.price)) { const old = document.createElement('del'); old.textContent = money(variant.price); priceEl.append(old); }
    const amount = document.createElement('strong'); amount.textContent = money(price); priceEl.append(amount);
    if (price < Number(variant.price)) {
      const saving = document.createElement('small'); saving.style.display = 'block';
      saving.textContent = t('You save ', '節省 ') + money(Number(variant.price) - price); priceEl.append(saving);
    }
    $('.campaign-gifts').disabled = !eligible;
    $('.campaign-gift-lock').hidden = eligible;
    const gifts = selectedGifts();
    const total = gifts.reduce((sum, item) => sum + item.quantity, 0);
    const maxQuantity = campaign.config.max_total_quantity;
    const overLimit = total > maxQuantity;
    const valid = total > 0 && !overLimit && gifts.every(item => Number.isInteger(item.quantity));
    const giftWarning = $('.campaign-gift-warning');
    giftWarning.hidden = !eligible || !overLimit;
    giftWarning.textContent = overLimit
      ? t(`You can select up to ${maxQuantity} gifts. Please reduce the selected quantity.`, `最多可選擇 ${maxQuantity} 份禮品，請減少所選數量。`)
      : '';
    $('.campaign-summary').textContent = eligible
      ? `${t('Selected gifts', '已選禮品')}: ${total} / ${maxQuantity} · ${money(price)} + ${t('free gifts', '免費禮品')}`
      : eligibilityMessage();
    $('.campaign-continue').disabled = busy || !eligible || !valid || !variant.availableForSale || price > Number(variant.price);
    if (!variant.availableForSale) message(t('This variant is sold out.', '此款式已售罄。'), true);
    if (eligible && price > Number(variant.price)) message(t('This offer price is unavailable. Please contact the store.', '優惠價格暫不可用，請聯絡商店。'), true);
    root.querySelectorAll('.campaign-gift').forEach(card => card.classList.toggle('selected', card.querySelector('input').type === 'radio' ? card.querySelector('input').checked : Number(card.querySelector('input').value) > 0));
  }
  async function apply(code) {
    const result = await request(`/campaign/${encodeURIComponent(campaignId)}/apply`, { code });
    if (!result.eligible) throw new Error(eligibilityMessage());
    eligible = true; grant = result.grant; campaign.config = result.config;
    saved[campaignId] = { ...(saved[campaignId] || {}), grant };
    if (grant) {
      store?.saveApproval(campaignId, grant);
      if (!campaign.domainAccepted) store?.rememberDestination(campaignId);
    }
    message(t('Promotion applied.', '優惠已套用。')); update();
  }
  $('.campaign-code-form').addEventListener('submit', async event => {
    event.preventDefault();
    if (!campaign.signedIn) {
      sessionStorage.setItem('pending-gift-code:' + campaignId, $('#campaign-code').value);
      sessionStorage.setItem('gift-promotion-return', location.pathname + location.search);
      await window.rememberPromotionReturn?.();
      location.href = $('.campaign-login').href; return;
    }
    const button = event.currentTarget.querySelector('button'); button.disabled = true;
    try { await apply($('#campaign-code').value); } catch (error) { message(error.message, true); }
    finally { button.disabled = false; }
  });
  $('.campaign-login').addEventListener('click', () => {
    sessionStorage.setItem('gift-promotion-return', location.pathname + location.search);
    if ($('#campaign-code').value.trim()) sessionStorage.setItem('pending-gift-code:' + campaignId, $('#campaign-code').value);
  });
  $('.campaign-continue').addEventListener('click', async () => {
    if (busy || !eligible || $('.campaign-continue').disabled) return; busy = true; update();
    try {
      const variant = currentVariant();
      saved[campaignId] = { grant, promotionItems: selectedGifts() };
      store?.saveSelection(campaignId, selectedGifts());
      const result = await request('/draft-order', {
        cartItems: [{ variantId: variant.id, quantity: 1 }],
        promotionItems: [],
        promotionSelections: [{ promotionId: campaignId, grant, promotionItems: selectedGifts() }],
        locale: root.dataset.locale
      });
      if (!result.success || !result.invoiceUrl) throw new Error(t('Unable to start checkout. Please retry.', '無法開始結帳，請重試。'));
      location.href = result.invoiceUrl;
    } catch (error) { busy = false; message(error.message, true); update(); }
  });
  async function loadProductContent() {
    const target = document.getElementById('promotion-product-content');
    if (!target || !campaign.product.handle) return;
    const url = root.dataset.root.replace(/\/$/, '') + '/products/' + encodeURIComponent(campaign.product.handle);
    const response = await fetch(url, { credentials: 'same-origin' });
    if (!response.ok) throw new Error('HTTP ' + response.status);
    const page = new DOMParser().parseFromString(await response.text(), 'text/html');
    const sections = Array.from(page.querySelectorAll('#MainContent > .shopify-section'))
      .filter(section => !section.querySelector('product-info, product-recommendations'));
    sections.forEach(section => section.querySelectorAll('script').forEach(script => script.remove()));
    if (!sections.length) return;
    target.replaceChildren(...sections.map(section => document.importNode(section, true)));
    target.hidden = false;
  }
  async function init() {
    if (!campaignId) throw new Error(t('This promotion is unavailable.', '此優惠暫不可用。'));
    campaign = await request('/campaign/' + encodeURIComponent(campaignId));
    if (campaign.signedIn) {
      sessionStorage.removeItem('gift-promotion-return');
      sessionStorage.removeItem('corporate_login_redirect');
    }
    $('.campaign-title').textContent = localized(campaign.config.table_titles) || campaign.config.name || campaign.product.title;
    $('.campaign-description').textContent = localized(campaign.config.table_subtitles);
    $('.campaign-product-title').textContent = campaign.product.title;
    if (campaign.product.featuredImage?.url) { const img = document.createElement('img'); img.src = campaign.product.featuredImage.url; img.alt = campaign.product.title; $('.campaign-photo').append(img); }
    $('.campaign-variant-label span').textContent = t('Product option', '產品款式');
    campaign.product.variants.nodes.forEach(variant => { const option = document.createElement('option'); option.value = variant.id; option.textContent = variant.title; $('.campaign-variant').append(option); });
    if (!campaign.product.variants.nodes.length) throw new Error('This product is unavailable.');
    $('.campaign-variant-label').hidden = campaign.product.variants.nodes.length === 1;
    $('.campaign-variant').addEventListener('change', update);
    campaign.config.products.forEach(product => {
      const card = document.createElement('label'); card.className = 'campaign-gift';
      if (product.shopify_image_url) { const img = document.createElement('img'); img.src = product.shopify_image_url; img.alt = ''; card.append(img); }
      const title = document.createElement('p'); title.textContent = localized(product.titles) || product.shopify_product_title; card.append(title);
      const input = document.createElement('input'); input.className = 'campaign-gift-input';
      input.type = campaign.config.max_total_quantity === 1 ? 'radio' : 'number'; input.name = 'campaign-gift';
      input.min = '0'; input.max = campaign.config.max_total_quantity; input.step = '1'; input.value = '0';
      input.dataset.key = product.key; input.dataset.variant = product.shopify_variant_id;
      if (input.type === 'number') { const qty = document.createElement('span'); qty.textContent = (localized(campaign.config.qty_labels) || t('Qty:', '數量：')) + ' '; card.append(qty); }
      input.setAttribute('aria-label', title.textContent); input.addEventListener('input', update); card.append(input);
      $('.campaign-gift-list').append(card);
    });
    $('.campaign-login').href = '/customer_authentication/login?return_to=' + encodeURIComponent(location.pathname + location.search);
    $('.campaign-login').hidden = campaign.signedIn;
    $('.campaign-register').hidden = campaign.signedIn;
    $('.campaign-layout').hidden = false; $('.campaign-status').hidden = true;
    loadProductContent().catch(error => console.warn('Unable to load product content', error));
    $('.campaign-code-form').hidden = !campaign.acceptsCode || campaign.domainAccepted === true;
    eligible = campaign.eligible === true;
    $('.campaign-gift-lock span').textContent = eligibilityMessage();
    if (!eligible) message(eligibilityMessage(), campaign.signedIn && campaign.state !== 'code_required');
    else message(t('Promotion applied.', '優惠已套用。'));
    if (!eligible && store?.invalidApprovalIds().includes(campaignId)) {
      message(t('Your saved approval has expired. Please enter your promotion code again.', '已儲存的優惠授權已過期，請重新輸入優惠碼。'));
    }
    (saved[campaignId]?.promotionItems || []).forEach(item => {
      const input = Array.from(root.querySelectorAll('.campaign-gift-input')).find(input => input.dataset.key === item.key && input.dataset.variant === item.shopify_variant_id);
      if (input) { if (input.type === 'radio') input.checked = item.quantity > 0; else input.value = item.quantity; }
    });
    update();
    if (campaign.domainAccepted === true) sessionStorage.removeItem('pending-gift-code:' + campaignId);
    const pending = sessionStorage.getItem('pending-gift-code:' + campaignId);
    if (campaign.signedIn && saved[campaignId]?.grant && !pending) {
      const result = await request('/eligibility', { grants: { [campaignId]: saved[campaignId].grant }, cartItems: [{ productId: campaign.product.id, quantity: 1 }] });
      const restored = result.promotions.find(p => p.id === campaignId);
      if (restored?.code_accepted) { eligible = true; grant = saved[campaignId].grant; campaign.config = restored; message(t('Promotion applied.', '優惠已套用。')); update(); }
      else if (result.invalidGrantIds?.includes(campaignId)) {
        store?.clearApproval(campaignId, saved[campaignId].grant);
        if (!eligible) message(t('Your saved approval is no longer valid. Please enter your promotion code again.', '已儲存的優惠授權已失效，請重新輸入優惠碼。'));
      }
    }
    if (campaign.signedIn && pending) {
      sessionStorage.removeItem('pending-gift-code:' + campaignId);
      await apply(pending || '');
    }
  }
  init().catch(error => { if (!campaign) $('.campaign-status').textContent = error.message; else message(error.message, true); });
})();
